import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { PRICE } from "@/lib/brand";

const CartContext = createContext(null);
const KEY = "mth_cart_v1";

const load = () => {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) || "[]");
    return Array.isArray(v) ? v : [];
  } catch {
    return [];
  }
};

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(load);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const add = useCallback((colour, size, quantity = 1) =>
    setItems((prev) => {
      const found = prev.find((i) => i.colour === colour && i.size === size);
      if (found) return prev.map((i) => (i === found ? { ...i, quantity: Math.min(20, i.quantity + quantity) } : i));
      return [...prev, { colour, size, quantity }];
    }), []);
  const setQty = useCallback((colour, size, quantity) =>
    setItems((prev) =>
      quantity <= 0
        ? prev.filter((i) => !(i.colour === colour && i.size === size))
        : prev.map((i) => (i.colour === colour && i.size === size ? { ...i, quantity: Math.min(20, quantity) } : i)),
    ), []);
  const clear = useCallback(() => setItems((prev) => (prev.length ? [] : prev)), []);

  const api = useMemo(() => {
    const count = items.reduce((s, i) => s + i.quantity, 0);
    return { items, add, setQty, clear, count, total: count * PRICE, open, setOpen };
  }, [items, open, add, setQty, clear]);

  return <CartContext.Provider value={api}>{children}</CartContext.Provider>;
};

export const useCart = () => useContext(CartContext);
